import { cx } from "../../lib/cx";
import { photoProps } from "../../lib/links";
import Accent from "../ui/Accent";

/**
 * Interior page head: the blueprint grid with an eyebrow, an uppercase
 * Oswald headline (*asterisks* mark Golden Sun words) and a lede. An
 * `image` sits in a frame beside the text on wide screens. `long` sizes
 * down sentence-length headlines; `children` render under the lede.
 */
export default function PageHero({
  eyebrow,
  title,
  lede,
  image,
  imageAlt = "",
  long = false,
  children,
  className,
}) {
  return (
    <section className={cx("blueprint px-4 text-white sm:px-6", className)}>
      <div
        className={cx(
          "mx-auto grid max-w-280 items-center gap-10 pt-16 pb-12 md:pt-20 md:pb-14",
          image && "lg:grid-cols-[minmax(0,1fr)_400px] lg:gap-14",
        )}
      >
        <div className="min-w-0">
          {eyebrow && <span className="eyebrow text-blue-soft">{eyebrow}</span>}
          <h1
            className={cx(
              "font-display mt-4 mb-4 max-w-[22ch] uppercase",
              long
                ? "max-w-[30ch] text-[32px] leading-[1.1] md:text-[44px]"
                : "text-[40px] md:text-[56px] lg:text-[64px]",
            )}
          >
            <Accent>{title}</Accent>
          </h1>
          {lede && (
            <p className="max-w-[640px] text-lg text-white/85">{lede}</p>
          )}
          {children && <div className="mt-7">{children}</div>}
        </div>
        {image && (
          <div className="hidden lg:block">
            <img
              {...photoProps(image, "400px")}
              alt={imageAlt}
              fetchPriority="high"
              className="aspect-[4/3] w-full rounded-brand border border-white/15 object-cover shadow-lift"
            />
          </div>
        )}
      </div>
    </section>
  );
}
